<script setup lang="ts">
import { resolveImg } from '@/composables/useGameImages'
/**
 * 單色 icon 染系統色：用 alpha 形狀當 mask + `background-color: var(--color-theme)`。
 * 用於「各款同形狀、只差系統色」的共用 icon（RULE_BUTTONS / HISTORY_ICONS 單色那些）。
 * 隱形 sizer img 維持原比例；overlay 填主題色。含 `-webkit-mask`（舊 MIUI Chromium 相容）。
 */
withDefaults(defineProps<{ src: string; width?: string }>(), { width: '100%' })
</script>

<template>
  <span class="tint-icon" :style="{ width }">
    <img :src="resolveImg(src)" alt="" class="tint-icon__sizer" draggable="false" />
    <span class="tint-icon__fill" :style="{ '--tint-mask': `url(${resolveImg(src)})` }" />
  </span>
</template>

<style scoped>
.tint-icon {
  position: relative;
  display: inline-block;
  line-height: 0;
}
.tint-icon__sizer {
  display: block;
  width: 100%;
  height: auto;
  visibility: hidden;
}
.tint-icon__fill {
  position: absolute;
  inset: 0;
  background-color: var(--color-theme);
  -webkit-mask: var(--tint-mask) center / contain no-repeat;
  mask: var(--tint-mask) center / contain no-repeat;
}
</style>
